import { Table, TableBody, TableContainer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PriceDisplay } from "../../../../../components/common/PriceDisplay";
import {
    StyledTableCell,
    StyledTableHead,
    StyledTableRow,
} from "../../../../../components/table/BaseTable/BaseTable";
import {
    formatDecimalNumber,
    getCalculatedPricingForProduct,
    getDiscountedPricesForProduct,
} from "../../../../../utils";
import { style } from "@mui/system";

import { roundToDecimalPlaces } from "../../../../../helpers/methods";

export const AgreementProductsTable = (props) => {
    const { products } = props;
    const { t } = useTranslation();

    const productRow = (product, discount) => {
        // const pricing = getCalculatedPricingForProduct(product);
        const discountedPricing = getDiscountedPricesForProduct(product, discount);
        return (
            <StyledTableRow key={product.id}>
                <StyledTableCell>{product.investment.investment_name_sales}</StyledTableCell>
                <StyledTableCell>{product.type?.name}</StyledTableCell>
                <StyledTableCell>{product.product_number}</StyledTableCell>
                <StyledTableCell>{product.name_full}</StyledTableCell>
                <StyledTableCell>{formatDecimalNumber(discount, 2)} %</StyledTableCell>
                <StyledTableCell>
                    <PriceDisplay price={discountedPricing.gross_per_sqm} perSquareMeter/>
                </StyledTableCell>
                <StyledTableCell>
                    <PriceDisplay price={discountedPricing.net_per_sqm} perSquareMeter/>
                </StyledTableCell>
                <StyledTableCell>
                    <PriceDisplay price={discountedPricing.gross} />
                </StyledTableCell>
                <StyledTableCell>
                    <PriceDisplay price={discountedPricing.net} />
                </StyledTableCell>
            </StyledTableRow>
        );
    };

    return (
        <TableContainer>
            <Table>
                <StyledTableHead>
                    <StyledTableRow>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.investment")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.type")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.number")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.name")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.discount")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.discountedOfferPriceGrossPerSqm")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.discountedOfferPriceNetPerSqm")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.discountedOfferPriceGross")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsTable.discountedOfferPriceNet")}
                        </StyledTableCell>
                    </StyledTableRow>
                </StyledTableHead>
                <TableBody>
                    {products.map((p) => productRow(p.product, p.discount_proc))}
                    {products.length === 0 && (
                        <StyledTableRow>
                            <StyledTableCell colSpan={10} align="center">
                                <Typography variant="body2">
                                    {t("agreements.AgreementProductsTable.noData")}
                                </Typography>
                            </StyledTableCell>
                        </StyledTableRow>
                    )}
                    {props.showTotalsAfterDiscount && products.length > 0 &&
                    <StyledTableRow>
                            <StyledTableCell colSpan={6}/> 
                            <StyledTableCell colSpan={1} align="left">
                                <Typography fontWeight={"bold"}>
                                    {t("agreements.AgreementProductsTable.total")}
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell colSpan={1} align="left">
                                <PriceDisplay style = {{fontWeight: "bold"}} price={products.reduce((currvalue, accumulator)=>{
                                    const discountedPricing = getDiscountedPricesForProduct(accumulator.product, accumulator.discount_proc);
                                    return currvalue + roundToDecimalPlaces(discountedPricing.gross, 2)
                                }, 0)} />
                            </StyledTableCell>
                            <StyledTableCell colSpan={1} align="left">
                                <PriceDisplay style = {{fontWeight: "bold"}} price={products.reduce((currvalue, accumulator)=>{
                                    const discountedPricing = getDiscountedPricesForProduct(accumulator.product, accumulator.discount_proc);
                                    return currvalue + roundToDecimalPlaces(discountedPricing.net, 2)
                                }, 0)} />
                            </StyledTableCell>
                        </StyledTableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
};
